/** India statutory / KYC document types for employee attachments. */

export const INDIA_EMPLOYEE_DOCUMENT_TYPES = [
  {
    value: 'PAN_Card',
    label: 'PAN card',
    help: 'Income-tax PAN card (Form 49A / e-PAN)',
  },
  {
    value: 'Aadhaar',
    label: 'Aadhaar',
    help: 'Aadhaar card or masked Aadhaar (last 4)',
  },
  {
    value: 'Passport',
    label: 'Passport',
    help: 'Passport bio page (optional for travel)',
  },
  {
    value: 'UAN_PF',
    label: 'UAN / PF proof',
    help: 'EPFO UAN card or PF passbook summary',
  },
  {
    value: 'ESI_Card',
    label: 'ESI card',
    help: 'ESIC insurance / pehchan card',
  },
  {
    value: 'Form16',
    label: 'Form 16 / TDS',
    help: 'Prior employer Form 16 or TDS statement',
  },
  {
    value: 'Bank_Proof',
    label: 'Bank proof',
    help: 'Cancelled cheque or passbook with IFSC',
  },
  {
    value: 'Insurance',
    label: 'Health / group insurance',
    help: 'Medical or group insurance certificate',
  },
  {
    value: 'Contract',
    label: 'Appointment / contract',
    help: 'Signed offer or employment contract',
  },
  {
    value: 'Certificate',
    label: 'Certificate / degree',
    help: 'Educational or professional certificates',
  },
  {
    value: 'Photo',
    label: 'Photo ID',
    help: 'Passport-size photograph',
  },
  {
    value: 'Other',
    label: 'Other',
    help: 'Any other employee compliance document',
  },
] as const;

export type IndiaEmployeeDocumentType = (typeof INDIA_EMPLOYEE_DOCUMENT_TYPES)[number]['value'];
